import React from 'react';

export const clearEmptyUnits = (_units) =>
  _units.filter(({ number, subunits }) =>
    parseInt(number, 10) < 1
      ? subunits.some(({ resources }) => resources.length > 0)
      : true,
  );

export const loadingBars = () => {
  const predefinedWidths = ['w-28', 'w-32', 'w-36', 'w-28', 'w-44', 'w-32'];
  return new Array(6).fill(undefined).map((_, i) => ({
    id: i,
    label: (
      <span
        className={`animate-pulse block ${predefinedWidths[i]} h-10 bg-gray-300 rounded-md`}
      />
    ),
    isActive: false,
    onClick: () => {},
  }));
};
